<template>
  <div id="password">
    <div class="d-flex justify-content-between align-self-center my-4">
      <AGCLabel>
        <span class="title">密碼</span>
        <template v-slot:subLabel>
          <span>
            密碼最少8個字，必須包含數字及大，小寫英文字母（不支援特殊符號）。
          </span>
        </template>
      </AGCLabel>
    </div>
    <AGCEditGroupPassword v-model="inputVal"
                          label="密碼"
                          type="password"
                          disabled
                          :enableEdit="!readOnly"
    >
    </AGCEditGroupPassword>
  </div>
</template>

<script>
import AGCEditGroupPassword from '../form/AGCEditGroupPassword.vue';
import AGCLabel from '../form/AGCLabel.vue';

import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  props: {
    readOnly: Boolean,
  },
  components: {
    AGCEditGroupPassword,
    AGCLabel,
  },
  mounted() {

  },
};
</script>
